import "./Faq01.css";

import React, { useRef, useState } from "react";
import PathBackground01 from "../../core/PathBackground01";

import { useScrollReveal } from "../../../hooks/useScrollReveal";

function Faq01() {
  const [activeIndex, setActiveIndex] = useState(10);
  const { ref, isVisible } = useScrollReveal();
  const faqTrackRef = useRef(null);

  const faqs = [
    {
      question: "What exactly does SERVED do?",
      answer:
        "SERVED is an automated DMCA takedown and leak protection agency built for content creators and models. We use advanced AI to continuously scan the web for your stolen content, unauthorized re-uploads, and fake profiles. Once a threat is detected, our system automatically issues legally binding takedown notices to get the content removed instantly, protecting your hard-earned revenue.",
    },
    {
      question: "What platforms do you actively monitor?",
      answer:
        "We cast a massive net. Our systems monitor the deepest corners of the web, including major social platforms (Reddit, Twitter/X, Telegram), massive tube sites, file-sharing hosts, and private forums where leaks are commonly traded.",
    },
    {
      question:
        "Will I have to fill out any legal paperwork or send emails myself?",
      answer:
        "No. Our team manages the entire enforcement process on your behalf. Detection, documentation, and takedown notices are handled internally so you can stay focused on creating while we handle the protection work.",
    },
    {
      question: "Can you remove fake profiles or impersonators?",
      answer:
        "Yes. Impersonators don't just steal your content; they steal your reputation and scam your fans. Our system flags and destroys fake social media accounts, fraudulent link-in-bio pages, and unauthorized fan pages trying to profit off your likeness.",
    },
    {
      question: "Is my personal information kept secure?",
      answer:
        "Your privacy is our absolute highest priority. We operate entirely as an authorized third-party agent on your behalf. This means your real name, address, and personal details stay completely out of the public DMCA notices. We act as your digital shield.",
    },
  ];

  const toggleAnswer = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };
  return (
    <div
      ref={(el) => {
        ref.current = el;
        faqTrackRef.current = el;
      }}
      className={`Faq01 section section-reveal ${isVisible ? "section--visible" : ""}`}
      id="Faq01"
    >
      <PathBackground01
        trackRef={faqTrackRef}
        className="Faq01-pathBg"
        markerCount={5} // same as FAQ count here
        trackMode="section-progress"
      />
      <div className="container">
        <div className="intro">
          <p className="eyebrow">FAQs</p>
          <h2>Frequently Asked Questions.</h2>
          <p>
            Find out more about us and answers to the most frequently asked
            questions.
          </p>
        </div>

        <div className="Faq01-box">
          {faqs.map((faq, index) => (
            <div key={index} onClick={() => toggleAnswer(index)}>
              <h4>{faq.question}</h4>
              {activeIndex === index && <p className="answer">{faq.answer}</p>}
            </div>
          ))}
        </div>

        <a href="/faq" className="link">
          View All
        </a>
      </div>
    </div>
  );
}

export default Faq01;
